import { fromFetch } from 'rxjs/fetch';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { placesEnvironment } from '../places-environment';
import { placeDetailsSchema } from '../schemas/place-details.schema';

/**
 * Get the details of a place based on the provided TrimblePlaceId
 * @param placeId The TrimblePlaceId for the place
 * @param attributeSource The attribute source. By default, any custom attributes are returned (if present).
 * If no attributes are customized, Trimble MAPS managed attributes are returned.
 * @returns The place details
 */
export function getPlaceDetails(
  this: unknown,
  request: {
    attributeSource?: 'Custom' | 'Trimble';
    placeId: string;
  }
) {
  const params =
    typeof request.attributeSource === 'undefined'
      ? ''
      : `?${new URLSearchParams([['attributeSource', request.attributeSource]]).toString()}`;

  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${placesEnvironment.resolve(this).placesPlacePlaceIdDetailsUrl(request.placeId)}${params}`,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(selectData(placeDetailsSchema));
}
